const base = "/api";
const api = {
  User: base + "/user",
  Question: base + "/question",
  Answer: base + "/answer",
  UploadFace: base + "/uploadImage",
  UploadVideo: base + "/uploadVideo"
}
export default api;
